/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const t=Symbol("widget"),e=Symbol("widget-test-data");export{t as widgetSymbol,e as widgetTestDataSymbol};
